// extracted by mini-css-extract-plugin
export default {"panel":"panel--J_4hJ","fields":"fields--igojL","section":"section--FeqHH","field":"field--V_Ruy"};